export const formatDate = (isoString) => {
  const date = new Date(isoString);
  return date.toLocaleDateString("en-GB"); // 'en-GB' formatea la fecha como DD/MM/YYYY
};
